var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.discount)?_c('label',{staticClass:"subtitle discount"},[_vm._v("-"+_vm._s(_vm.subtitle)+" "+_vm._s(_vm.currency))]):_c('label',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle)+" "+_vm._s(_vm.currency))])])
}
var staticRenderFns = []

export { render, staticRenderFns }